import Input from "@/components/Input/Input";
import { HStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

type Props = CFormItemProps & {
  value?: string;
  onChange: (value?: string) => void;
  allowNegative?: boolean;
  unit?: string;
  inputWidth?: number | string;
  inputClassName?: string;
};

/**
 * Card-based Form / DecimalItem
 */
export const CFormDecimalItem = buildCFormItem((props: Props) => {
  return (
    <CFormItemBase
      {...props}
      readComponent={
        <HStack className="gap-1 items-baseline">
          {props.value}
          {typeof props.unit === "string" ? (
            <Text variant="labelReg">{props.unit}</Text>
          ) : (
            props.unit
          )}
        </HStack>
      }
      writeComponent={
        <HStack className="gap-2 items-center">
          <Input
            type="number"
            inputMode="decimal"
            min={props.allowNegative ? undefined : 0}
            value={props.value ?? 0}
            onChange={(e) => {
              const value = e.target.value;
              props.onChange(value === "" ? undefined : value);
            }}
            width={props.inputWidth}
            className={props.inputClassName}
          />
          {typeof props.unit === "string" ? (
            <Text variant="labelReg">{props.unit}</Text>
          ) : (
            props.unit
          )}
        </HStack>
      }
    />
  );
});
